// extracted by mini-css-extract-plugin
export default {"recos":"z5-z","productCardOverride":"A5-z","rowHasBadge":"B5-z"};